import authApi from '../../api/auth'
import userApi from '../../api/user'

// initial state
const state = {
  status: '',
  pin_token: '',
  user: {},
}

// getters
const getters = {
  isPinLoggedIn: state => !!state.pin_token,
  authStatus: state => state.status,
}

// actions
const actions = {

  pinLogin({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      authApi.pinLogin(user, res => {
        const pin_token = res.jwt
        //const user = res.data.user
        localStorage.setItem('pin_token', pin_token)
        authApi.setHeader(pin_token)
        userApi.getTimeclockMe(userResponse => {
          const user = userResponse
          commit('auth_success', {pin_token, user})
          resolve(res)
          // what if user isn't found? do we need an error callback?
        })
      },
      error => {
        commit('auth_error')
        localStorage.removeItem('pin_token')
        reject()
      })
    })
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('pin_token')
      authApi.removeHeader()
      resolve()
    })
  },

  getPinTokenFromStorage ({ commit }) {
    const pin_token = localStorage.getItem('pin_token')
    if (pin_token) {
      commit('setPinTokenFromStorage', pin_token)
      userApi.getTimeclockMe(userResponse => {
        const user = userResponse
        commit('auth_success', { pin_token, user })
      })
    }
  }
}

// mutations
const mutations = {
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, { pin_token, user }) {
    state.status = 'success'
    state.pin_token = pin_token
    state.user = user
  },
  set_user (state, user) {
    state.user = user
  },
  auth_error (state) {
    state.status = 'error'
  },
  logout (state) {
    state.status = ''
    state.pin_token = ''
    state.user = {}
  },
  setPinTokenFromStorage (state, pin_token) {
    state.pin_token = pin_token
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
